import React, { useEffect, useState } from "react";
import AdminDashboard from "./admindashboard";
import axios from "../api/baseurl";
import { useNavigate, useParams } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FiInfo } from "react-icons/fi";
import TestForPackage from "./testsByPackagePopup";
import { Pagination } from "react-bootstrap";
import { FaDownload } from 'react-icons/fa';

function ViewAppointmentsByEmployer() {
  const { userid } = useParams();
  const [appointmentDetails, setAppointmentDetails] = useState([]);
  const [loader, setLoader] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (searchTerm.trim()) {
      searchData(0);
    } else {
      getData(currentPage);
    }
  }, [searchTerm]);

  const searchData = async () => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    setLoader(true);
    try {
      const searchUrl = `/api/employeeappointment/userid=${userid}`;
      const response = await axios.get(searchUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setAppointmentDetails(response.data);
      // setFilteredData(response.data);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const getData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const token = JSON.parse(localStorage.getItem("data")).token;
      const trans = await axios.get(`/api/employeeappointment/getAllAppointmentsByUserid/userid=${userid}`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setAppointmentDetails(trans.data.content);
      // setFilteredData(trans.data.content);
      setCurrentPage(trans.data.number);
      setTotalPages(trans.data.totalPages);

      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);

    if (searchTerm.trim()) {
      searchData(newPage);
    } else {
      getData(newPage);
    }
  };
  const handleViewReport = (reportId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    const url = `/api/employee-appointment-reports/view/${reportId}`;
    axios({
      url,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const contentType = response.headers["content-type"] || "application/octet-stream";
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      window.open(blobUrl, "_blank");
    }).catch(() => toast.error("Failed to view report."));
  };

  const handleDownloadReport = (reportId, fileName) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    axios({
      url: `/api/employee-appointment-reports/view/${reportId}`,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const contentType = response.headers["content-type"] || "application/octet-stream";
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName || "report");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    }).catch(() => toast.error("Failed to download report."));
  };

  const handleBack = async (orgcode) => {
    navigate(`/users/companydetails/${orgcode}`);
  };

  const [loading, setLoading] = useState(null);
  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
      else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);

  const openTestsModal = (pkg) => {
    setSelectedPackage(pkg);
    setIsTestsModalOpen(true);
  };

  const closeTestsModal = () => {
    setSelectedPackage(null);
    setIsTestsModalOpen(false);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };



  return (
    <div>
      <div className="mb-2">
        <button className="btn btn-primary" onClick={() => handleBack(appointmentDetails.companycode)}>
          Back
        </button>
      </div>
      <div className="card card-raised">
        <div className="card-body">
          <div className="d-flex">

            <table className="table table-bordered">
              <thead>
                <tr className="table-header">
                  <th>Sl.No.</th>
                  <th>Employee Name</th>
                  <th>Date</th>
                  <th>Lab Name</th>
                  <th>Contact Number</th>
                  <th>Package Name</th>
                  <th>Appointment Status</th>
                  {/* <th>Report Id</th> */}
                  <th>Reports</th>

                </tr>
              </thead>
              <tbody>
                {appointmentDetails.length === 0 ? (
                  <tr>
                    <td colSpan="10" className="text-center">
                      No Data Available
                    </td>
                  </tr>
                ) : (
                  appointmentDetails.map((appointment, index) => (
                    <tr key={appointment.id}>
                      <td>{index + 1}</td>
                      <td>{appointment.emplo?.name} {appointment.emplo?.lastname}</td>
                      <td>{appointment.date}</td>
                      <td>{appointment.labs?.labname}</td>
                      <td>{appointment.emplo?.phoneno}</td>
                      <td>
                        {appointment.pack !== null && (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
                            <span style={{
                              backgroundColor: '#405469ff',
                              color: 'white',
                              padding: '6px 12px',
                              borderRadius: '20px',
                              fontWeight: '500',
                              display: 'inline-block',
                              fontSize: '14px'
                            }}>{appointment.pack?.packagename}</span>
                            <FiInfo
                              onClick={() => openTestsModal(appointment.packageid)}
                              style={{
                                cursor: 'pointer',
                                fontSize: '24px',
                              }}
                            />
                          </div>
                        )}

                        <div>
                          {appointment.additionalTest && appointment.additionalTest.length > 0 && (
                            <>
                              Additional Tests:
                              <ul style={{ margin: 0, paddingLeft: "20px" }}>
                                {
                                  appointment.additionalTest.map((test, i) => (
                                    <li key={i}>{test.testDetails?.testname}</li>
                                  ))

                                }
                              </ul>
                            </>
                          )}
                        </div>
                      </td>
                      <td> {appointment.appStatus?.appointmentStatus === "APPOINTMENT RESCHEDULED" ? (
                        `Appointment Rescheduled on ${appointment.appStatus?.dateTime} by ${appointment.appStatus?.updatedBy}`
                      ) : appointment.appStatus?.appointmentStatus === "APPOINTMENT CANCELLED" ? (
                        `Appointment Cancelled on ${appointment.appStatus?.dateTime} by ${appointment.appStatus?.updatedBy}`
                      ) :
                        appointment.appStatus?.appointmentStatus === "APPOINTMENT CONFIRMED" ? (
                          `Appointment Confirmed on ${appointment.appStatus?.dateTime} by ${appointment.appStatus?.updatedBy}`
                        ) : (
                          appointment.appStatus?.appointmentStatus
                        )}
                      </td>
                      {/* <td>
                        {(appointment.reports || []).length > 0 ? (
                          <ul className="list-unstyled mb-0">
                            {(appointment.reports || []).map((report) => (
                              <li key={report.id}>{report.id}</li>
                            ))}
                          </ul>
                        ) : "N/A"}
                      </td> */}
                      <td>
                        {appointment.orderStatus ? (
                          appointment.orderStatus?.appointmentReport ? (
                            appointment.reportstatus === 'APPROVED' ? (
                              <div>
                                {/* Display the appointment report as a link if approved */}
                                <a
                                  href={appointment.orderStatus.appointmentReport}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  View Report
                                </a>
                              </div>
                            ) : (
                              "APPROVAL PENDING"
                            )
                          ) : (
                            "No Report Added"
                          )
                        ) : (
                          appointment.reportstatus ? (
                            appointment.reportstatus === 'APPROVED' ? (
                              <>
                                {(appointment.reports || []).length > 0 ? (
                                  <ul className="list-unstyled mb-0">
                                    {(appointment.reports || []).map((report, ri) => (
                                      <li key={report.id} className="d-flex align-items-center justify-content-between mb-1" style={{ gap: '6px' }}>
                                        <span
                                          style={{ cursor: 'pointer', color: '#0d6efd', textDecoration: 'underline', fontSize: '13px', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                          onClick={() => handleViewReport(report.id)}
                                          title={report.fileName || `File ${ri + 1}`}
                                        >
                                          {report.fileName || `File ${ri + 1}`}
                                        </span>
                                        <FaDownload
                                          size={14}
                                          style={{ cursor: 'pointer', color: '#198754', flexShrink: 0 }}
                                          title="Download"
                                          onClick={() => handleDownloadReport(report.id, report.fileName)}
                                        />
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <span className="text-muted" style={{ fontSize: '12px' }}>No files</span>
                                )}
                              </>
                            ) : (
                              "APPROVAL PENDING"
                            )
                          ) : (
                            "No Report Added"
                          )
                        )}
                      </td>

                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-center">
            <Pagination>
              <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
              <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
              {renderPageNumbers()}
              <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
              <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
            </Pagination>
          </div>
        </div>
        {isTestsModalOpen && (
          <TestForPackage
            isOpen={isTestsModalOpen}
            onRequestClose={closeTestsModal}
            packageId={selectedPackage}
          />
        )}
        {loader && <div className="loading"></div>}
      </div>

    </div>
  );
}

export default ViewAppointmentsByEmployer;
